import { GridSortItem } from '@mui/x-data-grid-pro';
import { createStore, withProps } from '@ngneat/elf';
import { withEntities, withUIEntities } from '@ngneat/elf-entities';
import { withPagination } from '@ngneat/elf-pagination';
import { withRequestsStatus } from '@ngneat/elf-requests';

import { TableConfig } from '@constants/table.constants';
import { TablePagination } from '@store/common/pagination.model';
import { Audit, AuditUI, AuditsFilters } from './audits.model';

export interface AuditsState {
  filters: AuditsFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
  auditsMerge: Audit[];
}

export const auditsStore = createStore(
  { name: 'audits' },
  withProps<AuditsState>({
    filters: { search: '', tableFilters: AuditsFilters.initTableFilters() },
    sort: {
      field: 'createdAt',
      sort: 'desc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
    auditsMerge: [],
  }),
  withEntities<Audit>(),
  withUIEntities<AuditUI>(),
  withPagination(),
  withRequestsStatus()
);
